import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/dashboardFiltersSaga";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const MonthSwitcher = () => {
  const dispatch = useDispatch();
  const date = useSelector((state) => state.dashboardFilters.date);
  const calendarEndDate = useSelector((state) => state.commonReducer.commonProps.calendarEndDate);
  const dateFormat = useDateFormat();

  useEffect(() => {
    dispatch(actionCreators.updateDate(calendarEndDate));
  }, []);

  const updateDates = (startDate, endDate) => {
    if (date !== endDate) {
      dispatch(actionCreators.updateDate(endDate));
    }
  };

  return (
    <div id="monthSwitcher">
      <div className="select-wrapper">
        <p className="offers-title">Month to Date</p>
        <ReactDatePicker
          displayFormat={dateFormat}
          startDate={date}
          calendarEndDate={calendarEndDate}
          updateDates={updateDates}
        />
      </div>
    </div>
  );
};

export default MonthSwitcher;
